import { render, staticRenderFns } from "./PhoneSet.vue?vue&type=template&id=a4295bc0"
import script from "./PhoneSet.vue?vue&type=script&lang=js"
export * from "./PhoneSet.vue?vue&type=script&lang=js"
import style0 from "./PhoneSet.vue?vue&type=style&index=0&id=a4295bc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports